import errorHandler from './ErrorHandler';
import Analytics from '../../globals/Analytics';

const setWindowProperties = () => {
	const { href, search } = document.location;

	window.MODULE = 'CustomerView';
	window.QUERY = search;
	window.Analytics = Analytics;
	window.onerror = errorHandler;

	if (href.indexOf('/logowanie') > -1) {
		window.MODULE = 'LoginRegister';
	}

	if (
		href.indexOf('/konto/rejestracja') > -1
        || href.indexOf('rejestracja-dostawcy.html') > -1
        || href.indexOf('/wybierz-klientow') > -1
	) {
		window.MODULE = 'LoginRegister';
	}

	if (href.indexOf('/zobacz') > -1 || href.indexOf('/rfp') > -1) {
		window.MODULE = 'PublicView';
	}

	if (href.indexOf('/moje-zapytania') > -1) {
		window.MODULE = 'BuyerView';
	}
	if (href.indexOf('/formularz') > -1) {
		window.MODULE = 'RfpForm';
	}
	if (href.indexOf('/buyer-app-profile') > -1) {
		window.MODULE = 'BuyerAppProfile';
	}
};

export default setWindowProperties;
